import { useRef, useCallback } from "react";
import useAxios from "../utils/useAxios";
import {getGuestTokenConfig} from "../constants";

export const getNormalizedSets = (sets) => {
    if (!sets || !Array.isArray(sets)) return [];
    const arr = [];
    sets.forEach((s, backendIndex) => {
        const num = s.number !== undefined ? s.number : backendIndex + 1;
        const idx = num - 1;
        arr[idx] = { ...s, number: num };
    });
    for (let i = 0; i < arr.length; i++) {
        if (!arr[i]) arr[i] = { number: i + 1 };
    }
    return arr;
};

export const useMatchSync = (tournamentId, onApiSuccess) => {
    const api = useAxios();

    // Храним состояние отправки и очередь для КАЖДОГО матча
    const isRequesting = useRef({});
    const pendingPayloads = useRef({});

    const syncMatch = useCallback((matchId, newFields) => {
        // 1. Складываем новые поля в очередь матча
        if (!pendingPayloads.current[matchId]) {
            pendingPayloads.current[matchId] = { main: {} };
        }

        Object.entries(newFields).forEach(([key, value]) => {
            if (key === 'sets') {
                // Если приходит массив, мы его сохраняем.
                // В случае частичного апдейта (один сет), он придет как массив из одного элемента.
                pendingPayloads.current[matchId].sets = value;
            } else {
                pendingPayloads.current[matchId].main[key] = value;
            }
        });

        // 2. Если запрос УЖЕ идет, выходим.
        // Данные отправятся мгновенно после завершения текущего запроса.
        if (isRequesting.current[matchId]) return;

        // 3. Функция для мгновенной отправки очереди
        const flushQueue = async () => {
            if (!pendingPayloads.current[matchId]) return;

            const accumulated = pendingPayloads.current[matchId];
            const payload = { ...accumulated.main };

            if (accumulated.sets) {
                // Бэкенд трактует "id" в элементе sets как создание новой записи
                // и падает с "set with this id already exists.", если id уже
                // существует в БД - апсертит существующий сет по (матч, number),
                // так что id перед отправкой убираем.
                // "number" шлём только начиная со 2-го сета: для 1-го сета (и
                // для ~95% турниров, где матч состоит из одного сета) бэкенд
                // считает отсутствие number как number=1.
                payload.sets = accumulated.sets.map(({ id, number, ...rest }, idx) => {
                    const setNumber = number !== undefined ? number : idx + 1;
                    return setNumber > 1 ? { ...rest, number: setNumber } : rest;
                });
            }

            if (Object.keys(payload).length === 0) return;

            // Очищаем локальную очередь перед запросом (чтобы клики во время запроса копились в новую)
            delete pendingPayloads.current[matchId];
            isRequesting.current[matchId] = true;

            const config = getGuestTokenConfig(tournamentId, { 'Content-Type': 'application/json' });

            try {
                const res = await api.patch(`/api/v1.0/tournaments/${tournamentId}/matches/${matchId}/`, payload, config);
                console.log(res.data.updated_matches)
                if (onApiSuccess) onApiSuccess(res);
            } catch (e) {
                console.error("Match sync error:", e);
            } finally {
                isRequesting.current[matchId] = false;
                // Рекурсивно проверяем: если пока шел запрос админ накликал еще - отправляем дальше!
                if (pendingPayloads.current[matchId]) {
                    flushQueue();
                }
            }
        };

        // Запускаем мгновенно! (0мс задержки = молниеносные сокеты)
        flushQueue();
    }, [api, tournamentId, onApiSuccess]);

    return syncMatch;
};
